// order manager 上报
import { commonRequest } from '@/common/utils/request'
import { getIsOrderManager, getLoginAccountId, getLoginShopid, getLoginShopName, getRegionByCookie, getWebId } from '@RootCommon/utils'
import { getIsDesktopWindows } from '@/common/utils'
import { AreaEnum, MArea } from '@sailor/i18n-web'
import { getHornConfig } from '@RootCommon/utils/horn'

const isOrderManager = getIsOrderManager()
const isDesktopWindows = getIsDesktopWindows()
const isGCC = [...MArea.getRegionsByArea(AreaEnum.GCC)].includes(getRegionByCookie())

const DEVICE_TYPE = {
  WINDOWS: 2, // om windows
  WEB: 1, // om web
  PORTAL: 4,
}

export const getDeviceType = () => {
  if (isOrderManager) {
    return isDesktopWindows ? DEVICE_TYPE.WINDOWS : DEVICE_TYPE.WEB
  }
  if (isGCC) {
    return DEVICE_TYPE.PORTAL
  }
}

export const getCommonParams = () => ({
  shopId: getLoginShopid(),
  shopName: getLoginShopName(),
  deviceUuid: getWebId(),
  deviceSn: getWebId(),
  reportTime: Date.now(),
  isWebVisible: document.visibilityState === 'visible' ? 1 : 0,
})

async function getRetryConfig () {
  const config = await getHornConfig()
  return config.retryConfig
}

/**
 * 设备状态心跳上报
 * @param deviceType 设备类型
 * @param heartReportType 心跳上报类型 1: 轮询心跳上报 2: 探活心跳上报
 */
export async function deviceHeartBeat (deviceType: number, heartReportType: 1 | 2, payload: { networkType: string; networkDelay: number }) {
  const retryConfig = await getRetryConfig()
  return commonRequest.post('/api/operate/device/report', {
    deviceType,
    heartReportType,
    ...getCommonParams(),
    ...payload,
  }, { ...retryConfig }) as Promise<{
    reportGapTime: number
  }>
}

// 设备心跳统计数据上报
export async function deviceHeartBeatDataReport (
  deviceType: number,
  heartReportInfo: {
    periodCost: number // 上报周期
    total: number // 心跳上报次数
    failed: number // 失败次数
    tp50: number // 前50%耗时
    tp90: number // 前90%耗时
    tp99: number // 前99%耗时
  },
) {
  const retryConfig = await getRetryConfig()
  return commonRequest.post('/api/operate/device/heartbeatDataReport', {
    deviceType,
    ...getCommonParams(),
    heartReportInfo: JSON.stringify(heartReportInfo),
  }, { ...retryConfig }) as Promise<{
    reportGapTime: number
  }>
}

// 网络上报
export async function networkReport (
  deviceType: number,
  networkCondition: {
    netStatus: number
    trigger: string
    urlTime: Array<{
      time: number
      httpCode: number
      url: string
    }>
  },
) {
  const retryConfig = await getRetryConfig()
  return commonRequest.post('/api/operate/device/networkReport', {
    deviceType,
    ...getCommonParams(),
    networkCondition: JSON.stringify(networkCondition),
  }, { ...retryConfig }) as Promise<{
    reportGapTime: number
  }>
}

export const DEVICE_REPORT_TYPE = {
  PRINTER: 3,
  NO_SOUND_PERMISSION: 4,
}

/**
 * 设备相关上报 deviceType 3: 打印上报 4: 无声音权限上报
 * @param deviceType 上报类型
 * @param extension 扩展参数, 用于打印机配置上报时需要传入打印配置等信息
 */
export async function deviceReport (deviceType: number, extension?: { [key: string]: any }) {
  const retryConfig = await getRetryConfig()
  const uuid = getWebId()
  return commonRequest.post('/api/operate/device/deviceDataReport', {
    shopId: getLoginShopid(),
    userId: deviceType === DEVICE_REPORT_TYPE.PRINTER ? getLoginAccountId() : undefined,
    deviceUuid: uuid,
    deviceType,
    extension: JSON.stringify(extension),
  }, { ...retryConfig })
}
